import { useMemo } from 'react'

import { useFetchBankAccounts } from '@features/bankAccounts/hooks/useFetchBankAccounts'

interface UseBankAccountByBookkeepingAccountIdOptions {
  enabled?: boolean
}

export const useBankAccountByBookkeepingAccountId = (
  bookkeepingAccountId?: string,
  options: UseBankAccountByBookkeepingAccountIdOptions = {},
) => {
  const { bankAccounts, isLoading } = useFetchBankAccounts(options)

  const bankAccount = useMemo(
    () => bankAccounts.find((account) => account.bookkeepingAccountId === bookkeepingAccountId),
    [bankAccounts, bookkeepingAccountId],
  )

  return {
    accountTotalBalance: bankAccount?.bookedBalance?.value ?? 0,
    balanceCurrency: bankAccount?.bookedBalance?.currency ?? '',
    ...bankAccount,
    isLoading,
  }
}
